import React, { useEffect, useState } from 'react';
import './CP58Form.css'; // Import external CSS file
import { get, getDatabase, ref } from 'firebase/database';
import { firebaseApp } from '../../..';
import { downloadSrikandiData } from '../../../API';
import { useAuth } from '../../../Context/AuthContext';

const CP58Form = () => {
    const [icNumber, setIcNumber] = useState(Array(21).fill(''));
    const [companyCukaiPendapatan, setCompanyCukaiPendapatan] = useState(Array(10).fill(''));
    const [penerimaCukaiPendapatan1, setPenerimaCukaiPendapatan1] = useState(Array(2).fill(''));
    const [penerimaCukaiPendapatan2, setPenerimaCukaiPendapatan2] = useState(Array(11).fill(''));
    const [icAkuan, setIcAkuan] = useState(Array(13).fill(''));
    const [mastautin, setMastautin] = useState(Array(1).fill(''));
    const [user, setUser] = useState<any>('');
    const { user: currentUser, dbUser } = useAuth();

    useEffect(() => {
        downloadSrikandiData('3Gkc9YakZdMPyldfEnEhdDYbH3u2').then((data) => {
            setUser(data);
        });
    }, []);
    return (
        <div className="cp58-container">
            {/* Header */}
            <div className="cp58-header">
                <p
                    style={{
                        fontSize: '13px',
                        fontWeight: 'bold',
                        marginBottom: '-8px',
                        fontFamily: 'system-ui',
                    }}
                >
                    PENYATA BAYARAN INSENTIF BERBENTUK WANG TUNAI DAN BUKAN WANG TUNAI KEPADA EJEN,
                </p>
                <p
                    style={{
                        fontSize: '13px',
                        fontWeight: 'bold',
                        marginBottom: '-4px',
                        fontFamily: 'system-ui',
                    }}
                >
                    PENGEDAR ATAU PENGAGIH TERTAKLUK KEPADA SEKSYEN 83A AKTA CUKAI PENDAPATAN 1967
                </p>
                <p style={{ fontSize: '13px', marginBottom: '-6px', fontFamily: 'math' }}>
                    STATEMENT OF MONETARY AND NON-MONETARY INCENTIVE PAYMENT TO AN AGENT,
                </p>
                <p style={{ fontSize: '13px', marginBottom: '-5px', fontFamily: 'math' }}>
                    DEALER OR DISTRIBUTOR PURSUANT TO SECTION 83 A OF THE INCOME TAX ACT 1967
                </p>
                <p
                    style={{
                        fontSize: '10px',
                        fontWeight: 'bold',
                        marginBottom: '-4px',
                        fontFamily: 'system-ui',
                    }}
                >
                    Borang ini ditetapkan di bawah seksyen 152 Akta Cukai Pendapatan 1967
                </p>
                <p style={{ fontSize: '10px', marginBottom: '-3px', fontFamily: 'system-ui' }}>
                    This form is prescribed under section 152 of the Income Tax Act 1967
                </p>

                <hr style={{ outline: 'auto', opacity: '3.5', marginTop: '6px' }}></hr>
            </div>

            <div className="cp58-year-container" style={{ marginTop: '-15px' }}>
                <div className="cp58-section" style={{ textAlign: 'center', marginTop: '-5px' }}>
                    <p style={{ fontSize: '11px', fontWeight: 'bold', marginBottom: '-10px' }}>
                        BAGI TAHUN BERAKHIR 31 DISEMBER /
                    </p>
                    <p style={{ fontSize: '11px' }}>FOR THE YEAR ENDED 31 DECEMBER</p>
                </div>

                <div className="cp58-box" style={{ borderWidth: 'thin', marginTop: '-10px' }}>
                    <p></p>
                </div>
            </div>

            {/* BAHAGIAN A */}
            <>
                <div className="cp58-header-box">
                    <span style={{ color: 'white', marginLeft: '5px', fontSize: '11px' }}>
                        BAHAGIAN A / PART A: MAKLUMAT SYARIKAT PEMBAYAR / PAYER COMPANY'S
                        PARTICULARS
                    </span>
                </div>

                <div className="cp58-company-container">
                    <div className="cp58-section" style={{ width: '125px' }}>
                        <p style={{ fontSize: '11px', width: 'max-content' }}>1. Nama / Name</p>
                    </div>
                    <input
                        value={'SITI KHADIJAH APPAREL SDN BHD'}
                        className="cp58-input"
                        style={{ marginTop: '1px', background: '#c9c9fc' }}
                    />
                </div>
                <div className="cp58-company-container">
                    <div className="cp58-section" style={{ width: '125px' }}>
                        <p style={{ fontSize: '11px', width: 'max-content' }}>
                            2. Alamat / Address
                        </p>
                    </div>
                    <input
                        value={'Lot 3, Jalan Nilam 3, Nilai Impian, 71800 Nilai, Negeri Sembilan'}
                        className="cp58-input"
                        style={{ marginTop: '1px', background: '#c9c9fc' }}
                    />
                </div>
                <div className="cp58-company-container" style={{ marginTop: '1px' }}>
                    <label style={{ fontSize: '11px', width: '625px' }}>
                        3. No. Rujukan (No. Pendaftaran) / Reference No. (Registration No.)
                    </label>
                    <div className="ic-input-box">
                        {icNumber.map((digit, index) => (
                            <input
                                style={{ background: '#c9c9fc' }}
                                key={index}
                                id={`ic-${index}`}
                                type="text"
                                value={digit}
                            />
                        ))}
                    </div>
                </div>

                <div className="cp58-company-container" style={{ marginTop: '1px' }}>
                    <label style={{ fontSize: '11px', width: '372px' }}>
                        4. No. Cukai Pendapatan / Income Tax No.
                    </label>
                    <div className="ic-input-box">
                        {companyCukaiPendapatan.map((digit, index) => (
                            <input
                                style={{ background: '#c9c9fc' }}
                                key={index}
                                id={`ic-${index}`}
                                type="text"
                                value={digit}
                            />
                        ))}
                    </div>
                </div>
            </>

            {/* BAHAGIAN B */}
            <br></br>
            <>
                <div className="cp58-header-box">
                    <span style={{ color: 'white', marginLeft: '5px', fontSize: '11px' }}>
                        BAHAGIAN B / PART B : MAKLUMAT PENERIMA / RECIPIENT'S PARTICULARS
                    </span>
                </div>
                <p
                    style={{
                        fontSize: 'xx-small',
                        fontWeight: 'bold',
                        marginBottom: '0px',
                        margin: '2px',
                    }}
                >
                    Maklumat Penerima hendaklah diisi dengan lengkap dan mandatori / Recipient's
                    particulars are mandatory to be completely filled up
                </p>
                <div className="cp58-company-container">
                    <div className="cp58-section" style={{ width: '125px' }}>
                        <p style={{ fontSize: '11px', width: 'max-content' }}>1. Nama / Name</p>
                    </div>
                    <input
                        value={user.name}
                        className="cp58-input"
                        style={{ marginTop: '1px', background: '#c9c9fc' }}
                    />
                </div>
                <div className="cp58-company-container">
                    <div className="cp58-section" style={{ width: '125px' }}>
                        <p style={{ fontSize: '11px', width: 'max-content' }}>
                            2. Alamat / Address
                        </p>
                    </div>
                    <input
                        value={user?.profile?.address}
                        className="cp58-input"
                        style={{ marginTop: '1px', background: '#c9c9fc' }}
                    />
                </div>
                <div className="cp58-company-container" style={{ marginTop: '1px' }}>
                    <label style={{ fontSize: '11px', width: '625px' }}>
                        3. No. Pendaftaran / Kad Pengenalan / Polis / Tentera / Pasport *
                        Registration / Identity Card / Police / Army / Passport No. * ( * Potong
                        yang tidak berkenaan / Delete whichever is not applicable )
                    </label>
                    <div className="ic-input-box">
                        {user?.profile?.ic_number
                            ? user?.profile?.ic_number
                                  .split('')
                                  .map((digit: any, index: any) => (
                                      <input
                                          style={{ background: '#c9c9fc', fontSize: '11px' }}
                                          key={index}
                                          id={`ic-${index}`}
                                          type="text"
                                          value={digit}
                                      />
                                  ))
                            : icAkuan.map((digit: any, index: any) => (
                                  <input
                                      style={{ background: '#c9c9fc', fontSize: '11px' }}
                                      key={index}
                                      id={`ic-${index}`}
                                      type="text"
                                      value={digit}
                                  />
                              ))}
                    </div>
                </div>

                <div className="cp58-company-container" style={{ marginTop: '1px' }}>
                    <label style={{ fontSize: '11px', width: '227px' }}>
                        4. No. Cukai Pendapatan / Income Tax No.
                    </label>
                    <div className="ic-input-box" style={{ marginRight: '10px' }}>
                        {user?.profile?.eLHDNTin
                            ? user?.profile?.eLHDNTin
                                  .split('')
                                  .slice(0, 2)
                                  .map((digit: any, index: any) => (
                                      <input
                                          style={{ background: '#c9c9fc', fontSize: '11px' }}
                                          key={index}
                                          id={`ic-${index}`}
                                          type="text"
                                          value={digit}
                                      />
                                  ))
                            : penerimaCukaiPendapatan1.map((digit, index) => (
                                  <input
                                      style={{ background: '#c9c9fc', fontSize: '11px' }}
                                      key={index}
                                      id={`ic-${index}`}
                                      type="text"
                                      value={digit}
                                  />
                              ))}
                    </div>
                    <div className="ic-input-box">
                        {user?.profile?.eLHDNTin
                            ? user?.profile?.eLHDNTin
                                  .split('')
                                  .slice(3, 14)
                                  .map((digit: any, index: any) => (
                                      <input
                                          style={{ background: '#c9c9fc', fontSize: '11px' }}
                                          key={index}
                                          id={`ic-${index}`}
                                          type="text"
                                          value={digit}
                                      />
                                  ))
                            : penerimaCukaiPendapatan2.map((digit, index) => (
                                  <input
                                      style={{ background: '#c9c9fc', fontSize: '11px' }}
                                      key={index}
                                      id={`ic-${index}`}
                                      type="text"
                                      value={digit}
                                  />
                              ))}
                    </div>
                </div>
                <div>
                    <p
                        style={{
                            fontSize: '9px',
                            marginLeft: '251px',
                            marginTop: '-4px',
                            marginBottom: '0px',
                        }}
                    >
                        ▲ Isi / Enter : C / C1 / TN / PT / SG / OG / D / TP / TJ / TF
                    </p>
                </div>
                <div className="cp58-company-container" style={{ marginTop: '1px' }}>
                    <label style={{ fontSize: '11px', width: '264px' }}>
                        5. Mastautin di Malaysia / Resident in Malaysia
                    </label>
                    <div className="ic-input-box">
                        {mastautin.map((digit, index) => (
                            <input
                                style={{ background: '#c9c9fc', fontSize: '11px' }}
                                key={index}
                                id={`ic-${index}`}
                                type="text"
                                value={1}
                            />
                        ))}
                        <p
                            style={{
                                fontSize: 'xx-small',
                                fontWeight: 'bold',
                                marginLeft: '10px',
                            }}
                        >
                            1 = Ya / Yes 2 = Tidak / No
                        </p>
                    </div>
                </div>
            </>

            {/* BAHAGIAN C */}
            <br></br>
            <>
                <div className="cp58-header-box">
                    <span style={{ color: 'white', marginLeft: '5px', fontSize: '11px' }}>
                        BAHAGIAN C / PART C : MAKLUMAT BAYARAN INSENTIF / PARTICULARS OF INCENTIVE
                        PAYMENT
                    </span>
                </div>
                <div className="cp58-company-container">
                    <div className="cp58-section">
                        <b style={{ fontSize: '11px', width: 'max-content' }}>
                            1. Nilai insentif berbentuk wang tunai / Value of monetary incentive
                        </b>
                    </div>
                </div>
                <div className="cp58-company-container">
                    <p
                        style={{
                            fontSize: '11px',
                            width: 'max-content',
                            marginLeft: '10px',
                            minWidth: '600px',
                            marginTop: '1px',
                            marginBottom: '0px',
                        }}
                    >
                        (a) Komisen / bonus / Commission / bonus
                    </p>
                    <input
                        className="cp58-input"
                        style={{
                            marginTop: '1px',
                            background: '#c9c9fc',
                            border: '2px solid black',
                            height: '25px',
                            marginBottom: '0px',
                        }}
                    />
                </div>
                <div className="cp58-company-container">
                    <p
                        style={{
                            fontSize: '11px',
                            width: 'max-content',
                            marginLeft: '10px',
                            minWidth: '200px',
                            marginTop: '1px',
                            marginBottom: '0px',
                        }}
                    >
                        (b) Lain-lain / Others
                    </p>
                    <input
                        className="cp58-input"
                        style={{
                            marginTop: '1px',
                            marginRight: '5px',
                            background: '#c9c9fc',
                            border: '2px solid black',
                            height: '25px',
                            marginBottom: '0px',
                        }}
                    />
                    <input
                        className="cp58-input"
                        style={{
                            marginTop: '1px',
                            width: '267px',
                            background: '#c9c9fc',
                            border: '2px solid black',
                            height: '25px',
                            marginBottom: '0px',
                        }}
                    />
                </div>

                <div className="cp58-company-container">
                    <p
                        style={{
                            fontSize: '11px',
                            width: 'max-content',
                            marginLeft: '297px',
                        }}
                    >
                        (Sila nyatakan / Please specify )
                    </p>
                </div>
                <div className="cp58-company-container">
                    <b
                        style={{
                            fontSize: '11px',
                            width: 'max-content',
                            marginLeft: '470px',
                            minWidth: '140px',
                            marginTop: '-15px',
                            marginBottom: '0px',
                        }}
                    >
                        JUMLAH A / TOTAL A :
                    </b>
                    <input
                        className="cp58-input"
                        style={{
                            marginTop: '-15px',
                            background: '#c9c9fc',
                            border: '2px solid black',
                            height: '25px',
                            marginBottom: '0px',
                        }}
                    />
                </div>

                <div className="cp58-company-container">
                    <div className="cp58-section">
                        <b style={{ fontSize: '11px', width: 'max-content' }}>
                            2. Nilai insentif berbentuk bukan wang tunai / Value of non-monetary
                            incentive
                        </b>
                    </div>
                </div>
                <div className="cp58-company-container">
                    <p
                        style={{
                            fontSize: '11px',
                            width: 'max-content',
                            marginLeft: '10px',
                            minWidth: '600px',
                            marginTop: '1px',
                            marginBottom: '0px',
                        }}
                    >
                        (a) Kenderaan / Vehicle
                    </p>
                    <input
                        className="cp58-input"
                        style={{
                            marginTop: '1px',
                            background: '#c9c9fc',
                            border: '2px solid black',
                            height: '25px',
                            marginBottom: '0px',
                        }}
                    />
                </div>
                <div className="cp58-company-container">
                    <p
                        style={{
                            fontSize: '11px',
                            width: 'max-content',
                            marginLeft: '10px',
                            minWidth: '600px',
                            marginTop: '1px',
                        }}
                    >
                        (b) Rumah / House
                    </p>
                    <input
                        className="cp58-input"
                        style={{
                            marginTop: '1px',
                            background: '#c9c9fc',
                            border: '2px solid black',
                            height: '25px',
                        }}
                    />
                </div>
                <div className="cp58-company-container">
                    <p
                        style={{
                            fontSize: '11px',
                            width: 'max-content',
                            marginLeft: '10px',
                            minWidth: '600px',
                            marginTop: '-6px',
                        }}
                    >
                        (c) Pakej pelancongan / perjalanan / Tour / travel package
                    </p>
                    <input
                        className="cp58-input"
                        style={{
                            marginTop: '1px',
                            background: '#c9c9fc',
                            border: '2px solid black',
                            height: '25px',
                        }}
                    />
                </div>
                <div className="cp58-company-container">
                    <p
                        style={{
                            fontSize: '11px',
                            width: 'max-content',
                            marginLeft: '10px',
                            minWidth: '200px',
                            marginTop: '-6px',
                        }}
                    >
                        (b) Lain-lain / Others
                    </p>
                    <input
                        className="cp58-input"
                        style={{
                            marginTop: '-6px',
                            marginRight: '5px',
                            background: '#c9c9fc',
                            border: '2px solid black',
                            height: '25px',
                        }}
                    />
                    <input
                        className="cp58-input"
                        style={{
                            marginTop: '1px',
                            width: '267px',
                            background: '#c9c9fc',
                            border: '2px solid black',
                            height: '25px',
                        }}
                    />
                </div>
                <div className="cp58-company-container">
                    <p
                        style={{
                            fontSize: '11px',
                            width: 'max-content',
                            marginLeft: '297px',
                        }}
                    >
                        (Sila nyatakan / Please specify )
                    </p>
                </div>
                <div className="cp58-company-container">
                    <b
                        style={{
                            fontSize: '11px',
                            width: 'max-content',
                            marginLeft: '470px',
                            minWidth: '140px',
                            marginTop: '-15px',
                        }}
                    >
                        JUMLAH B / TOTAL B :
                    </b>
                    <input
                        className="cp58-input"
                        style={{
                            marginTop: '-15px',
                            background: '#c9c9fc',
                            border: '2px solid black',
                            height: '25px',
                        }}
                    />
                </div>
                <div className="cp58-company-container">
                    <b
                        style={{
                            fontSize: '11px',
                            width: 'max-content',
                            marginLeft: '260px',
                            minWidth: '350px',
                            marginTop: '18px',
                        }}
                    >
                        JUMLAH KESELURUHAN / TOTAL AMOUNT :
                    </b>
                    <input
                        className="cp58-input"
                        style={{
                            marginTop: '15px',
                            background: '#c9c9fc',
                            border: '2px solid black',
                            height: '25px',
                        }}
                    />
                </div>
                <div className="cp58-company-container">
                    <b
                        style={{
                            fontSize: '11px',
                            width: '3671px',
                            textAlign: 'center',
                            marginTop: '15px',
                        }}
                    >
                        3. . Jumlah potongan cukai 2% di bawah seksyen 107D ACP / An amount of 2%
                        tax deduction under section 107D ITA 2% X Jumlah A / 2% X Total A
                    </b>
                    <input
                        className="cp58-input"
                        style={{
                            marginTop: '15px',
                            background: '#c9c9fc',
                            border: '2px solid black',
                            height: '25px',
                        }}
                    />
                </div>
            </>
            {/* BAHAGIAN D */}
            <br></br>
            <>
                <div className="cp58-header-box">
                    <span style={{ color: 'white', marginLeft: '5px', fontSize: '11px' }}>
                        BAHAGIAN D / PART D : AKUAN PEMBAYAR / PAYER'S DECLARATION
                    </span>
                </div>
                <p style={{ fontSize: '11px' }}>
                    Saya / I{' '}
                    <input
                        className="cp58-input"
                        style={{
                            marginTop: '1px',
                            background: '#c9c9fc',
                            border: '2px solid black',
                            height: '25px',
                            width: '716px',
                        }}
                    />{' '}
                    <br></br>
                    No. Pendaftaran / Kad Pengenalan / Polis / Tentera / Pasport *{' '}
                    <div style={{ display: 'contents' }}>
                        {icAkuan.map((digit, index) => (
                            <input
                                style={{
                                    marginLeft: index === 0 ? '189px' : 0,
                                    marginTop: '3px',
                                    background: '#c9c9fc',
                                    width: '20px',
                                    height: '20px',
                                    textAlign: 'center',
                                    fontSize: '18px',
                                    border: '1px solid black',
                                }}
                                key={index}
                                id={`ic-${index}`}
                                type="text"
                                value={digit}
                            />
                        ))}
                    </div>{' '}
                    <br></br>
                    Registration / Identity Card / Police / Army / Passport No. * <br></br>
                    <small>
                        ( * Potong yang tidak berkenaan / Delete whichever is not applicable )
                    </small>{' '}
                    <br></br>
                    Jawatan / Designation{' '}
                    <input
                        className="cp58-input"
                        style={{
                            marginTop: '1px',
                            background: '#c9c9fc',
                            border: '2px solid black',
                            height: '20px',
                            width: '605px',
                            marginLeft: '38px',
                        }}
                    />{' '}
                    <br></br>dengan ini mengakui bahawa maklumat yang diberikan dalam penyata ini
                    adalah benar, betul dan lengkap seperti mana yang dikehendaki di bawah seksyen
                    83A Akta Cukai Pendapatan 1967. Saya juga sedia maklum bahawa kegagalan menyedia
                    dan menyerahkan salinan penyata ini kepada ejen, pengedar atau pengagih
                    berkenaan dalam tempoh yang ditetapkan oleh Akta tersebut adalah merupakan suatu
                    kesalahan, dan jika disabitkan kesalahan, boleh dikenakan denda tidak kurang
                    daripada dua ratus ringgit (RM200) dan tidak melebihi dua puluh ribu ringgit
                    (RM20,000) atau hukuman penjara untuk satu tempoh tidak melebihi enam (6) bulan
                    atau kedua-duanya sekali di bawah subseksyen 120(1) Akta yang sama. <br></br>
                    <br></br>hereby declare that the information given in this statement is true,
                    correct and complete as required under section 83A of the Income Tax Act 1967. I
                    am also aware that failure to prepare and render a copy of this statement to the
                    relevant agent, dealer or distributor within the period stipulated by the Act is
                    an offence and shall, on conviction, be liable to a fine of not less than two
                    hundred ringgit (RM200) and not more than twenty thousand ringgit (RM20,000) or
                    to imprisonment for a term not exceeding six (6) months or to both under
                    subsection 120(1) of the same Act.
                </p>
                <div style={{ display: 'flex' }}>
                    <p style={{ fontSize: '11px', marginLeft: '585px', marginTop: '1px' }}>
                        Tarikh / Date :
                    </p>{' '}
                    <input
                        className="cp58-input"
                        style={{
                            marginTop: '1px',
                            background: '#c9c9fc',
                            border: '2px solid black',
                            height: '20px',
                            width: '100px',
                        }}
                    />{' '}
                </div>
                <div>
                    <p style={{ fontSize: '7px' }}>
                        ** Nota: Pengakuan ini hendaklah dibuat oleh pemegang jawatan dalam syarikat
                        selaras dengan peruntukan Akta Cukai Pendapatan 1967 <br></br>
                        ** Note: This declaration must be made by a designated officer of the
                        company pursuant to the Income Tax Act 1967
                    </p>
                </div>
            </>
        </div>
    );
};

export default CP58Form;
